import VacanciesCard from './VacanciesCard.vue';

export default VacanciesCard;



// WEBPACK FOOTER //
// ./src/pages/vacancies/card/index.ts